import React, { Component } from 'react'
import AOS from 'aos';
import './css/knowledge.css'
import bulbs from '../../assets/images/bulbs.svg'
import online from '../../assets/images/online.svg'

class Knowledge extends Component {
    componentDidMount() {
        // or simply just AOS.init();
        AOS.init({
          // initialise with other settings
          duration : 1000
        });
      }
    render() {
        return (
            <div className="knowledge">
                <div className="know">
                    <div className="imageKnow">
                        <img src={bulbs} alt="bulb"/>
                    </div>

                    <div className="other" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1600">
                        <h1>PAY THE PRICE, <br/>GET THE VALUE</h1>
                        <p>The forex market sees a constant growth & more people are acknowledging the profitability potential of trading and are tapping into the opportunities it presents. Financial liberation is a hundred percent attainable as long as one is consistently committed & dedicated to a continuous sound education. Also, subscribing to take the course doesn't end there, it requires patience, resilience, attentiveness, consistency, and determination to be able to become proficient. We are poised to usher our students to success, laying the foundation to help them set realistic goals and teaching the values of independence, monitoring their growth, and guiding them through the way.</p>
                    </div>
                </div>

                <div className="knows">
                    <div className="others" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1600">
                        <h1>OUR PLATFORM</h1>
                        <p>Our platform has been engineered to fit into any device for the convenience of our users. We have also made sure to make it an easy to navigate online learning platform. We’ve leveraged several technologies and tools in creating excellent quality educational content and the environment for the best learning experience.</p>
                    </div>

                    <div className="imageKnow2">
                        <img src={online} alt="bulb"/>
                    </div>

                </div>
            </div>  
        )
    }
}

export default Knowledge;